import { render } from "./AddOnAcquisitions.vue?vue&type=template&id=99faf8ca"
import script from "./AddOnAcquisitions.vue?vue&type=script&lang=js"
export * from "./AddOnAcquisitions.vue?vue&type=script&lang=js"

import "./AddOnAcquisitions.vue?vue&type=style&index=0&id=99faf8ca&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__